import { Brick, registerBrick, Auth, AuthProtocol, Config } from 'olympe';
import { binaryToString, fromBase64, getLogger } from '@olympeio/core';

export default class GetUserTokenInfo extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} _inputs
     * @param {function(string)} setDisplayName
     * @param {function(?string)} setEmail
     * @param {function(string)} setName
     */
    update($, _inputs, [setDisplayName, setEmail, setName, setAlternativeEmail]) {
        Auth.observeUser($).subscribe(() => {
            // Get full token of the current user
            const { user: username, protocol, payload } = Auth.getUserToken();
            // noinspection JSUnreachableSwitchBranches
            switch (protocol) {
                // Decode JWT token
                case AuthProtocol.OAUTH2:
                    const token = getOAuthTokenAsJSON(payload);
                    // get the token for authorization for subsequent api calls
                    // const bearerToken = getAuthTokenForApi();
                    // getLogger("::GetUserTokenInfo::").info(bearerToken, "Bearer Token is::")
                    const { name, upn, family_name, given_name, unique_name } = token;
                    const displayName = (family_name && given_name) ?
                        `${given_name} ${family_name.toUpperCase()}` : (name || upn);
                    getLogger('GetUserTokenInfo').info('displayName,upn,unique_name, name:: ', displayName, upn, unique_name, name)
                    setDisplayName(displayName);
                    setEmail(upn);
                    setAlternativeEmail(unique_name)
                    setName(name || null);
                    break;

                // Decode SAML token
                case AuthProtocol.SAML:
                    const { displayname, emailaddress } = getSAMLTokenAsJSON(payload);
                    getLogger('GetUserTokenInfo').info('displayname,emailaddress:: ', displayname, emailaddress)
                    setDisplayName(displayname);
                    setEmail(emailaddress);
                    setAlternativeEmail(emailaddress)
                    setName(null);
                    break;

                // Get info from Cloud Object
                case AuthProtocol.SRP:
                    setDisplayName(username);
                    setEmail(null);
                    setName(null);
                    setAlternativeEmail(null)
                    break;

                // Unknown type
                default:
                    getLogger('GetUserTokenInfo').error('Token protocol is unknown');
            }
        });
    }
}

/**
 * @param {Object} token
 * @return {!Object}
 */
function getSAMLTokenAsJSON(token) {
    try {
        /*const xmlAttributesRx = /<Attribute Name="([^"]+)"><AttributeValue>([^<]+)<\/AttributeValue>/g;
        const xmlAttributes = [...token.matchAll(xmlAttributesRx)];

        // Map XML to JSON
        return xmlAttributes
            .map(([_0, name, _2]) => [_0, name.substring(name.lastIndexOf('/') + 1), _2])
            .reduce((acc, [_, name, value]) => ({...acc, [name]: value}), {});*/
        return {
            displayname:
                token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname'] +
                ' ' +
                token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname']?.toUpperCase(),
            emailaddress: token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress']
        }
    }
    // Error while transforming SAML to JSON
    catch (e) {
        getLogger('GetUserTokenInfo').error('SAML <-> JSON error: ', e);
        return {};
    }
}

/**
 * @public
 * @param {Object} token
 * @return {!Object}
 */
export function getOAuthTokenAsJSON(token) {
    try {
        // Get the payload part of the token
        const [_header, base64Payload] = token['access_token']?.split('.');
        const decodedPayload = binaryToString(fromBase64(base64Payload));
        // Done
        return JSON.parse(decodedPayload);
    }
    // Error while decoding
    catch (e) {
        getLogger('GetUserTokenInfo').error('OAuth <-> JSON error: ', e);
        return {};
    }
}


registerBrick('01880508c0f9e7f34e5c', GetUserTokenInfo);
